import SEOHead from '@/components/common/SEOHead';
const SecurityPolicyPage = () => {
  return (
    <div className="bg-m2-background">
      <SEOHead
        title="Chính sách bảo mật | Trung tâm M2MBA"
        description="Chính sách bảo mật của Trung tâm M2MBA mô tả cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của học viên, đối tác và khách truy cập."
        url="/security-policy"
        type="website"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Chính sách bảo mật | Trung tâm M2MBA",
          "url": "https://m2mba.com/privacy-policy",
          "description": "Chính sách bảo mật của Trung tâm M2MBA mô tả cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân.",
          "publisher": {
            "@type": "EducationalOrganization",
            "name": "M2MBA Academy",
            "url": "https://m2mba.com",
            "logo": {
              "@type": "ImageObject",
              "url": "https://storage.googleapis.com/m2mba/f4872d86-57b4-4bb8-9492-f14a60f22280.jpg"
            },
             "sameAs": [
                "https://www.facebook.com/profile.php?id=100063494024929",
                "https://zalo.me/0983213076"
            ]
          }
        }}
      />

      <div className="eh-container py-16 sm:py-24">
        <div className="mx-auto max-w-3xl rounded-eh bg-m2-surface-lowest p-6 shadow-eh-soft sm:p-10">
          <p className="eh-eyebrow">Thông tin pháp lý</p>
          <h1 className="eh-display text-4xl sm:text-5xl mb-8">
            Chính sách bảo mật
          </h1>
          
          <div className="prose prose-lg prose-gray max-w-none">
            <p className="text-lg leading-8 text-m2-on-surface-variant mb-8">
              Chính sách bảo mật này mô tả cách Trung tâm M2MBA thu thập, sử dụng và bảo vệ thông tin cá nhân của học viên, đối tác và khách truy cập website. Chúng tôi cam kết bảo vệ dữ liệu cá nhân của bạn và tuân thủ các quy định pháp luật hiện hành.
            </p>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                1. Thông tin chúng tôi thu thập
              </h2>
              <p className="text-m2-on-surface mb-4">
                Chúng tôi có thể thu thập các loại thông tin sau:
              </p>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Thông tin cá nhân:
                  </h3>
                  <p className="text-m2-on-surface">
                    Tên, địa chỉ email, số điện thoại, ngày sinh, địa chỉ, và các thông tin liên hệ khác mà bạn cung cấp khi đăng ký khóa học, đăng ký nhận bản tin, hoặc tham gia các sự kiện.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Thông tin về học vấn và nghề nghiệp:
                  </h3>
                  <p className="text-m2-on-surface">
                    Thông tin về trình độ học vấn, kinh nghiệm làm việc, và mục tiêu nghề nghiệp khi bạn đăng ký các khóa học chuyên sâu.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Thông tin kỹ thuật:
                  </h3>
                  <p className="text-m2-on-surface">
                    Địa chỉ IP, loại trình duyệt, hệ điều hành, thời gian truy cập, và các trang bạn đã truy cập trên website của chúng tôi. Chúng tôi thu thập những thông tin này để cải thiện trải nghiệm người dùng và phân tích lưu lượng truy cập.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Thông tin thanh toán:
                  </h3>
                  <p className="text-m2-on-surface">
                    Thông tin liên quan đến các giao dịch thanh toán (qua cổng thanh toán của bên thứ ba) khi bạn mua khóa học. Chúng tôi không lưu trữ thông tin thẻ tín dụng hoặc tài khoản ngân hàng của bạn.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                2. Mục đích sử dụng thông tin
              </h2>
              <p className="text-m2-on-surface mb-4">
                Chúng tôi sử dụng thông tin cá nhân của bạn để:
              </p>
              <ul className="list-disc list-inside space-y-2 text-m2-on-surface">
                <li>Xử lý các yêu cầu đăng ký khóa học và thanh toán.</li>
                <li>Cung cấp các dịch vụ đào tạo và hỗ trợ học viên.</li>
                <li>Gửi thông báo về khóa học, tài liệu học tập, và các cập nhật quan trọng khác.</li>
                <li>Cải thiện chất lượng khóa học, website, và dịch vụ của chúng tôi.</li>
                <li>Gửi các bản tin, thông tin khuyến mãi, và các sự kiện sắp tới (nếu bạn đã đồng ý nhận).</li>
                <li>Thực hiện các hoạt động tiếp thị, quảng cáo phù hợp với sở thích của bạn.</li>
                <li>Ngăn chặn các hoạt động gian lận và đảm bảo an toàn cho hệ thống.</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                3. Chia sẻ thông tin cá nhân
              </h2>
              <p className="text-m2-on-surface mb-4">
                Chúng tôi cam kết không bán, cho thuê hoặc trao đổi thông tin cá nhân của bạn với bất kỳ bên thứ ba nào. Chúng tôi chỉ có thể chia sẻ thông tin trong các trường hợp sau:
              </p>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Với các bên cung cấp dịch vụ:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi có thể sử dụng các nhà cung cấp dịch vụ bên ngoài (ví dụ: nền tảng học trực tuyến, dịch vụ email marketing, xử lý thanh toán) để thực hiện các chức năng hỗ trợ. Các bên này chỉ được phép sử dụng thông tin của bạn để cung cấp dịch vụ cho chúng tôi và phải tuân thủ các thỏa thuận bảo mật nghiêm ngặt.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Khi có yêu cầu pháp lý:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi có thể tiết lộ thông tin cá nhân của bạn nếu được yêu cầu bởi pháp luật, theo lệnh của tòa án hoặc các cơ quan nhà nước có thẩm quyền.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Khi có sự đồng ý của bạn:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi sẽ chỉ chia sẻ thông tin của bạn với bên thứ ba khi có sự đồng ý rõ ràng của bạn.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                4. Bảo mật dữ liệu
              </h2>
              <p className="text-m2-on-surface">
                Chúng tôi áp dụng các biện pháp bảo mật kỹ thuật và tổ chức phù hợp để bảo vệ thông tin cá nhân của bạn khỏi truy cập trái phép, sử dụng sai mục đích hoặc tiết lộ. Dữ liệu của bạn được lưu trữ trên các máy chủ an toàn và được bảo vệ bằng tường lửa và mã hóa.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                5. Quyền của bạn
              </h2>
              <p className="text-m2-on-surface mb-4">
                Bạn có quyền:
              </p>
              <ul className="list-disc list-inside space-y-2 text-m2-on-surface">
                <li>
                  <strong>Truy cập và chỉnh sửa thông tin:</strong> Bạn có quyền yêu cầu truy cập và chỉnh sửa các thông tin cá nhân của mình. Để đảm bảo tính chính xác và bảo mật, mọi thay đổi đối với số điện thoại và email cá nhân của bạn sau khi đăng ký khóa học cần được thông báo và thực hiện thông qua chúng tôi.
                </li>
                <li>
                  <strong>Từ chối nhận thông tin tiếp thị:</strong> Nếu bạn không muốn nhận các thông tin tiếp thị từ chúng tôi, vui lòng liên hệ trực tiếp qua email hoặc số điện thoại của trung tâm để được hỗ trợ.
                </li>
                <li>
                  <strong>Yêu cầu xóa dữ liệu:</strong> Yêu cầu chúng tôi xóa thông tin cá nhân của bạn khỏi hệ thống, trừ các trường hợp mà pháp luật yêu cầu phải lưu giữ.
                </li>
                <li>
                  <strong>Khiếu nại:</strong> Nộp đơn khiếu nại lên cơ quan có thẩm quyền nếu bạn cảm thấy thông tin cá nhân của mình bị lạm dụng.
                </li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                6. Thay đổi chính sách bảo mật
              </h2>
              <p className="text-m2-on-surface">
                Chúng tôi có quyền cập nhật chính sách bảo mật này bất cứ lúc nào. Mọi thay đổi sẽ được công bố trên website của chúng tôi. Việc bạn tiếp tục sử dụng dịch vụ của chúng tôi sau khi có các thay đổi này đồng nghĩa với việc bạn chấp nhận các điều khoản đã được cập nhật.
              </p>
            </section>

            <div className="eh-panel eh-panel-sage p-6 mt-8">
              <p className="text-sm text-m2-on-surface-variant">
                <strong>Liên hệ:</strong> Nếu bạn có bất kỳ câu hỏi nào về chính sách bảo mật này, vui lòng liên hệ với chúng tôi qua email hoặc số điện thoại được cung cấp trên website.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SecurityPolicyPage